import { PLATFORMS } from "./config";
import { DEFAULT_PLATFORM } from "./constants";

export const getPlatformName = (value: number) => {
    const platform = PLATFORMS.find((p) => p.value === value);
    return platform ? platform.label : DEFAULT_PLATFORM;
};